/**
 * Client-side shipping method helpers.
 * Pickup detection mirrors server `lead-time-calculator.isPickupMethod`.
 */

/**
 * Whether a shipping method is customer pickup / collection (excluded from delivery estimates).
 *
 * @param {Object} [shippingMethod]
 * @returns {boolean}
 */
export function isPickupMethod(shippingMethod) {
  if (!shippingMethod) {
    return false;
  }

  if (shippingMethod.c_storePickupEnabled === true || shippingMethod.c_isPickup === true) {
    return true;
  }

  const id = String(shippingMethod.id || shippingMethod.code || '').toLowerCase();

  if (!id) {
    return false;
  }

  if (id === 'customer-pickup') {
    return true;
  }

  return id.includes('pickup');
}
